import { Box, Card, Typography, useTheme } from "@mui/material";
import Download from "src/Pages/Company/OrganizationStructure/DataManagment/assets/svg/Download";
import Upload from "src/Pages/Company/OrganizationStructure/DataManagment/assets/svg/Upload";
import __ from "src/utils/Translations";
import { FC } from "react";
import { IDataCards } from "./index";

const DataCard: FC<IDataCards> = ({
  mainText,
  secondaryText,
  actionButtons,
  type,
}) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "288px",
        width: "100%",
        maxWidth: "365px",
        padding: "32px",
        [theme.breakpoints.down("md")]: { maxWidth: "unset" },
      }}
    >
      <Box
        sx={{
          padding: "10px",
          backgroundColor: "#F7F8F8",
          borderRadius: "46px",
          width: "fit-content",
        }}
      >
        {type === "download" ? <Download /> : <Upload />}
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            fontSize: "17px",
            lineHeight: "150%",
            margin: "16px 0 8px 0",
          }}
          fontWeight="fontWeightMedium"
        >
          {__(mainText)}
        </Typography>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: "13px", color: "gray.400" }}>
          {__(secondaryText)}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          margin: "32px 0 0 0",
          fontWeight: "700",
          width: "100%",
          height: "100%",
        }}
      >
        {actionButtons}
      </Box>
    </Card>
  );
};

export default DataCard;
